<div class="dashboard-container" *ngIf="!isLoading">
  <main class="dashboard-main">
    <div class="dashboard-content">
      <div class="welcome-card">
        <div class="welcome-icon">
          <mat-icon>dashboard</mat-icon>
        </div>
        <h2>Welcome to Brand score AI - University AI score</h2>
        <p>Your comprehensive platform for brand analysis, education insights, and AI-powered recommendations.
        </p>
      </div>

      <div class="features-grid">
        <div class="feature-card" (click)="navigateToEducation('education-university')">
          <div class="feature-icon">
            <mat-icon>school</mat-icon>
          </div>
          <h3>Education Analysis</h3>
          <p>Analyze universities, courses, and educational institutions with AI-powered insights.</p>
        </div>

        <div class="feature-card" (click)="navigateToEducation('education-student')">
          <div class="feature-icon">
            <mat-icon>person</mat-icon>
          </div>
          <h3>AI Course Discovery</h3>
          <p>Discover AI courses and educational opportunities tailored for students.</p>
        </div>
      </div>

      <div class="quick-stats">
        <h3>Quick Overview</h3>
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-number">0</div>
            <div class="stat-label">Analyses Completed</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">0</div>
            <div class="stat-label">Reports Generated</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">0</div>
            <div class="stat-label">Insights Discovered</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

<div class="loading-container" *ngIf="isLoading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading your dashboard...</p>
</div>
